import React from 'react';

const TermsOfService = () => {
  return (
    <>
      <div className="h-60 bg-gray-20 flex flex-col items-center justify-start">
        <img
          src="/public/images/healthgrades-logo.svg"
          alt="Healthgrades logo"
          className="w-42 h-6 mt-12"
        />
        <div className="text-midnight-blue-90 font-semibold leading-[48px] text-[32px] w-[30%] text-center mt-4">
          Healthgrades Elevated Profile Terms of Service
        </div>
      </div>
      <div className="h-screen flex flex-col">
        <iframe
          src="/public/terms/terms.html"
          className="flex-1 border-none"
          title="Terms and Conditions"
          sandbox="allow-scripts allow-same-origin allow-popups"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </>
  );
};

export default TermsOfService;
